import moment from "moment";

export const scrollDiv = (id: string) => {
  const chat = document.getElementById(id);
  chat?.scrollIntoView();
};
export const convertFirstUpper = (val: string) => {
  return val ? val.charAt(0).toUpperCase() + val.slice(1) : "";
};
export const convertUpperCase = (val: string) => {
  return val ? val.toUpperCase() : "";
};
export const sortNumber = (list: any, label: string) => {
  return list.length > 0
    ? list.sort(
        (a: { [x: string]: number }, b: { [x: string]: number }) =>
          a[label] - b[label]
      )
    : [];
};
export const sortAlphabets = (list: any, label: string) => {
  console.log(list,label,"listlist")
  function customSort(a: { match: (arg0: RegExp) => string[]; localeCompare: (arg0: any) => any; }, b: { match: (arg0: RegExp) => string[]; }) {
    // Extract numerical part from the strings
    const numA = a&&a?.match(/\d+/)?parseInt(a?.match(/\d+/)[0]??0):0
    const numB =b&&b?.match(/\d+/)? parseInt(b?.match(/\d+/)[0]??0):0

    // Compare the numerical parts
    if (numA < numB) {
        return -1;
    }
    if (numA > numB) {
        return 1;
    }
    // If numbers are equal, compare the entire string
    return a.localeCompare(b);
}
  return list.length > 0
    ? list.sort((a: { [x: string]: any }, b: { [x: string]: any }) =>
      customSort(a[label].toLowerCase(),b[label].toLowerCase())
      )
    : [];
};
export const sortbyDate = (list: any, label: string) => {
  return list.length > 0
    ? list.filter((s: { [x: string]: any; })=>s[label]).sort((a: { [x: string]: any }, b: { [x: string]: any }) => {
        const datea = a[label];
        const dateb = b[label];
        var dateA: any = new Date(
          moment(new Date(datea)).format("MMM D YYYY h:mm:ss A")
        );
        var dateB: any = new Date(
          moment(new Date(dateb)).format("MMM D YYYY h:mm:ss A")
        );

        // Sort in descending order
        return dateB - dateA;
      })
    : [];
};
// const weight_mt = calculateCoilWeight(length_mm, width_mm, thickness_mm, estimated_density_kg_per_mm3);
export function formatTimestamp(timestampInSeconds: any,onlyDate?:any) {
  const date = moment(timestampInSeconds);
  const now = moment();
  const diffMinutes = now.diff(date, "minutes");
  console.log(diffMinutes,"diffMinutes")
  if(onlyDate){
    return date.format("MMM D, YYYY");
  }else if (now.isSame(date, "day")) {
    // Show time if it's today
    if ((diffMinutes < 60&&diffMinutes>0)||diffMinutes===0) {
      // If within 2 hours, show minutes ago
      return diffMinutes === 0
        ? "Just Now"
        : `${diffMinutes} min${diffMinutes !== 1 ? "s" : ""} ago`;
    } else {
      // Otherwise, show time
      return date.format("h:mm A");
    }
  } else if (now.clone().subtract(1, "days").isSame(date, "day")) {
    // Show yesterday if it was yesterday
    return `Yesterday at ${date.format("h:mm A")}`
  } else {
    // Show date and time for other dates
    return date.format("MMM D, h:mm A");
  }
}
export function formatDate(timeDate: any) {
  const date = moment(timeDate);
  const now = moment();

  if (now.isSame(date, "day")) {
    // Show time if it's today
    return "Today";
  } else if (now.clone().subtract(1, "days").isSame(date, "day")) {
    // Show yesterday if it was yesterday
    return "Yesterday";
  } else {
    // Show date and time for other dates
    return date.format("MMM D");
  }
}
export function formatTime(timestampInSeconds: any) {
  const date = moment(timestampInSeconds);
  const now = moment();
  const diffMinutes = now.diff(date, "minutes");
  // Show time if it's today
  if (diffMinutes < 60) {
    // If within 2 hours, show minutes ago
    return diffMinutes === 0
      ? "Just Now"
      : `${diffMinutes} min${diffMinutes !== 1 ? "s" : ""} ago`;
  } else {
    // Otherwise, show time
    return date.format("h:mm A");
  }
}
